import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ServiceProviderService } from '../../../Service/Service-providers/service-provider.service';

@Component({
  selector: 'app-promotion-dashboard-tabs',
  templateUrl: './promotion-dashboard-tabs.component.html',
  styleUrls: ['./promotion-dashboard-tabs.component.scss', '../promotion-dashboard.component.scss']
})
export class PromotionDashboardTabsComponent implements OnChanges {
  promotions: any[] = [];
  // @Input() totalRecords: number = 0;
  totalRecords: number = 0;
  promotionsList: any[] = [];
  pageNumber: number = 1;
  pageSize = 10;
  // totalPages: number = 1

  sortBy: string = '';
  sortDir: string = 'desc';
  @Input() status!: number;

  selectedActionPromo: any = null;
  isApproveAction: boolean = true;
  isReasonValid: boolean = false;
  actionReason: string = '';
  actionModalVisible: boolean = false;
  previewVisible = false;
  @Output() previewFile = new EventEmitter<any>();
  @Output() openAction = new EventEmitter<{ promo: any; isApprove: boolean }>();
  @Input() searchQuery: string = '';
  @Input() dateRange: Date[] = [];
  @Input() totalStatusRecords: number = 0;
  showStatusColumn: boolean = false;
  totalSubmittedRecord: number = 0;
  totalApprovedRecord: number = 0;
  totalRejectedRecord: number = 0;


  constructor(private serviceProviderService: ServiceProviderService) { }

  hasApprovedOrRejectedPromotions(): boolean {
  return this.promotions.some(promo => 
    promo.status === 'Approved' || promo.status === 'Rejected'
  );
}
  hideRejectedPromotions(): boolean {
  return this.promotions.some(promo => 
    promo.status === 'Approved' || promo.status === 'Submitted'
  );
}
  
  ngOnChanges(): void {
    this.pageNumber = 1;
    this.getAllPromotions();
  }
  setData(data: any[], totalRecords: number): void {
    this.promotions = data;
    this.totalRecords = totalRecords;
  }
  get hasMore(): boolean {
    return this.promotions.length < this.totalRecords;
  }
  openPreview(file: any): void {
    this.previewFile.emit(file);
  }
  getRequestParams(): any {
    const params: any = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortBy: this.sortBy,
      sortDir: this.sortDir,
      searchQuery: this.searchQuery,
      status: this.status
    };

    if (this.dateRange?.[0]) {
      params.startDate = this.formatDate(this.dateRange[0]);
    }

    if (this.dateRange?.[1]) {
      params.endDate = this.formatDate(this.dateRange[1]);
    }

    return params;
  }

  formatDate(date: Date | null): string | null {
    if (!date) {
      console.log('Date is null');
      return null;
    }
    const offset = date.getTimezoneOffset();
    const adjustedDate = new Date(date.getTime() - (offset * 60 * 1000));
    const formattedDate = adjustedDate.toISOString().split('T')[0];
    console.log('Formatted Date:', formattedDate);
    return formattedDate;
  }
  onChangeSearch(event: any): void {
    this.pageNumber = 1;
    this.getAllPromotions();
  }
  getAllPromotions() {
    const params = this.getRequestParams();
    this.serviceProviderService.getPromotions(params).subscribe({
      next: (response) => {
        console.log("API Response:", response);
        this.promotions = response.result.data
        // this.totalRecords = response.result.recordsTotal
        // this.totalRecords = response.result?.recordsTotal || 0;
        this.totalSubmittedRecord = response.totalSubmittedRecord;
        this.totalApprovedRecord = response.totalApprovedRecord;
        this.totalRejectedRecord = response.totalRejectedRecord;

        switch (this.status) {
        case 1: // Submitted
          this.totalRecords = this.totalSubmittedRecord;
          break;
        case 2: // Approved
          this.totalRecords = this.totalApprovedRecord;
          break;
        case 3: // Rejected
          this.totalRecords = this.totalRejectedRecord;
          break;
        default:
          this.totalRecords = response.result.recordsFiltered;
      }
      },
      error: (error) => {
        console.error("Error fetching promotions:", error);
        this.promotions = [];
        
      }
    });
  }

  shouldShowImage(fileName?: string): boolean {
    if (typeof fileName !== 'string') return false;

    const ext = fileName.split('.').pop()?.toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '');
  }
  openActionModal(promo: any, isApprove: boolean): void {
    this.openAction.emit({ promo, isApprove });
    // promo.status = isApprove ? 'Approved' : 'Rejected';
  }
  loadMorePromotions(): void {
    this.pageNumber++; // move to next page

    const params = this.getRequestParams();
    this.serviceProviderService.getPromotions(params).subscribe({
      next: (response) => {
        const newData = response.result?.data || [];
        this.promotions = [...this.promotions, ...newData];
        // this.totalRecords = response.result?.recordsTotal || this.totalRecords;
        // this.totalPages = Math.ceil(this.totalRecords / this.pageSize); 

        let tabTotal = 0;
      if (this.status === 1) {
        tabTotal = response.result.totalSubmittedRecord || 0;
      } else if (this.status === 2) {
        tabTotal = response.result.totalApprovedRecord || 0;
      } else if (this.status === 3) {
        tabTotal = response.result.totalRejectedRecord || 0;
      } else {
        tabTotal = response.result.recordsTotal || 0;
      }

      this.totalRecords = tabTotal;
      },
      error: (error) => {
        console.error('Error loading more promotions:', error);
      }
    });
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.totalRecords / this.pageSize));
  }

  getAvatarText(name: string): string {
    return name ? name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() : 'P';
  }


  getAttachmentName(url: string): string {
    return url.split('/').pop() || 'Attachment';
  }

  nextPage(): void {
    if (this.pageNumber < this.totalPages) {
      this.pageNumber++;
      this.getAllPromotions();
    }
  }

  previousPage(): void {
    if (this.pageNumber > 1) {
      this.pageNumber--;
      this.getAllPromotions();
    }
  }
}
